import { type RefObject, useEffect } from 'react';

export const useOnClickOutside = <T extends HTMLElement>(
  element: RefObject<T | null>,
  handler: () => void, // Function to be called when a click outside the element occurs
): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (element.current && !element.current.contains(event.target as Node)) {
        handler();
      }
    };

    document.addEventListener('mouseup', handleClickOutside);
    document.addEventListener('touchend', handleClickOutside);

    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
      document.removeEventListener('touchend', handleClickOutside);
    };
  }, [handler]);
};
